import { render } from "./VendorsCreateView.vue?vue&type=template&id=43c8b09e"
import script from "./VendorsCreateView.vue?vue&type=script&lang=js"
export * from "./VendorsCreateView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__